module.exports = __webpack_public_path__ + "media/images/world-banner-0828b9ab41a520d8e989e7f6c61ecaab.png";